import { useState } from "react";
import { useCachedResource } from "../hooks/useCachedResource";
import { useTranslation } from "react-i18next";
import { NeuCard } from "../components/neu/Neu";
import { SalesShell } from "../features/sales/SalesShell";
import { QuotationBuilder } from "../features/sales/QuotationBuilder";
import { listDocs, openDeliveries } from "../api/sales";

const KPIS = ["quotations", "orders", "deliveries", "openDeliveries"];

export default function SalesDashboardPage() {
  const { t } = useTranslation();
  const { data, reload: load } = useCachedResource("sales-dashboard", async () => {
    const [quotes, orders, deliveries, open] = await Promise.all([
      listDocs({ doc_type: "quotation", limit: 200 }),
      listDocs({ doc_type: "order", limit: 200 }),
      listDocs({ doc_type: "delivery", limit: 200 }),
      openDeliveries(),
    ]);
    return {
      quotations: (quotes.items || []).length,
      orders: (orders.items || []).length,
      deliveries: (deliveries.items || []).length,
      openDeliveries: (open || []).length,
      pipeline: (quotes.items || [])
        .filter((d) => ["sent", "accepted"].includes(d.state))
        .reduce((sum, d) => sum + Number(d.totals?.payable || 0), 0)
        .toFixed(2),
    };
  });
  const counts = data || {};

  return (
    <SalesShell titleKey="dashboard">
      <div className="grid gap-3 sm:grid-cols-4" data-testid="sales-kpis">
        {KPIS.map((key) => (
          <NeuCard key={key} className="p-4 sm:text-center" data-testid={`sales-kpi-${key}`}>
            <p className="text-[11px] text-muted-foreground">{t(`sales.kpi.${key}`)}</p>
            <p className="mt-1 font-mono text-2xl font-black">
              <span className="num inline-block">{counts[key] ?? 0}</span>
            </p>
          </NeuCard>
        ))}
      </div>

      <NeuCard className="p-4 sm:text-center" data-testid="sales-pipeline">
        <p className="text-[11px] text-muted-foreground">{t("sales.kpi.pipeline")}</p>
        <p className="mt-1 font-mono text-xl font-black text-primary">
          <span className="num inline-block">{counts.pipeline ?? "0.00"} AED</span>
        </p>
      </NeuCard>

      <QuotationBuilder onCreated={load} />
    </SalesShell>
  );
}
